import React, {Component} from "react";
import {Scrollbars} from "react-custom-scrollbars";

export default class ContentWrap extends Component {
    render() {
        return (
            <div style={{margin: 15, maxHeight: "calc(100vh - 100px)"}}>
                <Scrollbars autoHeight autoHeightMax={"calc(100vh - 100px)"}>
                    {this.props.children}
                </Scrollbars>
            </div>
        );
    }
}

